(function() {
  'use strict';

  function initEndlessPagination(container) {
    if (container.dataset.endlessPaginationInitialized) return;

    var section = container.parentElement;
    while (section && section.getAttribute('data-section-type') !== 'collection-template') {
      section = section.parentElement;
    }
    var productGrid = section && section.querySelector('.grid--view-items');
    var sentinel = container.querySelector('[data-endless-pagination-sentinel]');
    var loadingIndicator = container.querySelector('[data-endless-pagination-loading]');
    var fallbackLink = container.querySelector('[data-endless-pagination-next]');
    var nextUrl = container.dataset.nextUrl;
    var isLoading = false;
    var observer;

    container.dataset.endlessPaginationInitialized = 'true';

    function showFallback() {
      if (fallbackLink) fallbackLink.hidden = false;
    }

    if (!productGrid || !sentinel || !loadingIndicator || !nextUrl || !('IntersectionObserver' in window)) {
      showFallback();
      return;
    }

    function loadNextPage() {
      if (isLoading || !nextUrl) return;

      isLoading = true;
      loadingIndicator.hidden = false;
      if (fallbackLink) fallbackLink.hidden = true;

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function(response) {
          if (!response.ok) throw new Error('Unable to load the next collection page.');
          return response.text();
        })
        .then(function(html) {
          var nextPage = new DOMParser().parseFromString(html, 'text/html');
          var nextSection = nextPage.querySelector('[data-section-type="collection-template"]');
          var nextGrid = nextSection && nextSection.querySelector('.grid--view-items');
          var nextLink = nextSection && nextSection.querySelector('[data-endless-pagination-next]');

          if (!nextGrid) throw new Error('The next collection page has no product grid.');

          nextUrl = nextLink ? nextLink.getAttribute('href') : '';

          var products = document.createDocumentFragment();
          Array.prototype.slice.call(nextGrid.children).forEach(function(product) {
            products.appendChild(product);
          });
          productGrid.appendChild(products);
          loadingIndicator.hidden = true;

          if (fallbackLink && nextUrl) fallbackLink.setAttribute('href', nextUrl);

          isLoading = false;

          if (nextUrl) {
            observer.unobserve(sentinel);
            observer.observe(sentinel);
          } else {
            observer.disconnect();
          }
        })
        .catch(function() {
          loadingIndicator.hidden = true;
          isLoading = false;
          observer.disconnect();
          showFallback();
        });
    }

    observer = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) { return entry.isIntersecting; })) {
        loadNextPage();
      }
    }, { rootMargin: '200px 0px' });

    observer.observe(sentinel);
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-endless-pagination]'),
      initEndlessPagination
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
